/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    TOGGLE_ITEM_IN_WISH_LIST(state, item) {
        const index = state.wishList.findIndex(i => i.objectID == item.objectID)

        if (index < 0) {
            state.wishList.push(item)
        } else {
            state.wishList.splice(index, 1)
        }
    },
    TOGGLE_ITEM_IN_CART(state, item) {
        const index = state.cartItems.findIndex(i => i.objectID == item.objectID)

        if (index < 0) {
            state.cartItems.push(item)
        } else {
            state.cartItems.splice(index, 1)
        }

        localStorage.setItem('cart', JSON.stringify(state.cartItems));
    },
    CLEAR_CART(state) {
        state.cartItems = [];

        localStorage.setItem('cart', JSON.stringify(state.cartItems));
    },
    ADD_ITEM_IN_CART(state, item) {
        let index;

        if (item.measure_id != null && item.measure_id != '') {
            index = state.cartItems.findIndex(i => i.measure_id == item.measure_id)
        } else {
            index = state.cartItems.findIndex(i => i.objectID == item.objectID)
        }
        
        if (index != -1) {
            state.cartItems[index].quantity += item.quantity
            state.cartItems[index].price = parseFloat(parseFloat(state.cartItems[index].price) + parseFloat(item.price)).toFixed(2)
        } else {
            state.cartItems.push(item)
        }

        localStorage.setItem('cart', JSON.stringify(state.cartItems));
    },
    UPDATE_ITEM_QUANTITY(state, payload) {
        state.cartItems[payload.index].quantity = payload.quantity
        state.cartItems[payload.index].price = payload.price

        localStorage.setItem('cart', JSON.stringify(state.cartItems));
    }
}
